import { Card, Stack, StackProps } from '@mui/material'
import { ReactNode } from 'react'
import { Sidebar } from '~/features/sidebar'
import { useIsMobile } from '~/hooks/useIsMobile'
import { MobileMenu } from '~/features/sidebar/MobileMenu'
import { Outlet } from 'react-router'

export const AdminPageLayout = ({
  sx,
  backButton,
}: {
  backButton?: ReactNode
} & StackProps) => {
  const isMobile = useIsMobile()
  return (
    <Stack
      sx={{
        background: (t) => t.palette.background.paper,
        overflow: 'hidden',
        scrollBehavior: 'smooth',
        scrollPaddingTop: 120,
        ...sx,
      }}
      height={1}
      direction={isMobile ? 'column' : 'row'}
    >
      {!isMobile ? (
        <Stack flex={0.3} minWidth={300} m={2} mr={0}>
          <Sidebar />
        </Stack>
      ) : (
        <Stack sx={{ pt: 1, px: 2 }}>
          <MobileMenu />
        </Stack>
      )}
      <Stack gap={1} flex={1} m={2} sx={{ overflow: 'auto' }}>
        <Stack
          flex={1}
          sx={{ backgroundColor: 'background.default', overflow: 'unset' }}
          p={2}
          component={Card}
          elevation={0}
        >
          {backButton}
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  )
}
